import { assignInlineVars } from '@vanilla-extract/dynamic';

import { colors } from '../../colors';

import { divider, dividerLengthVar, dividerColorVar } from './Divider.css';

interface DividerProps {
    /** Divider direction, either horizontal — or vertical |  */
    orientation?: 'horizontal' | 'vertical';

    /** Optional length in px (horizontal: width; vertical: height; omitted => stretches in flex/grid). */
    length?: number;

    /** Optional color override, if overwritten with falsy then it defaults currentColor */
    color?: string;
}

export function Divider({ length, orientation = 'horizontal', color = colors.bluegray[200] }: DividerProps) {
    return (
        <hr
            className={divider({ orientation })}
            style={assignInlineVars({
                [dividerLengthVar]: length ? `${length}px` : undefined,
                [dividerColorVar]: color,
            })}
        />
    );
}
